import { ready } from '../../lib/lifecycle/ready';

if (typeof window.mdlrHeaderScrollPos === 'undefined') {
  window.mdlrHeaderScrollPos = 0;
}

function modulrHeaderScroll() {
  const headers = document.querySelectorAll('.wp-block-modulr-header');
  if (!headers || headers.length === 0) return;

  const wh = window.innerHeight;
  const topCompare = -(document.body.getBoundingClientRect()).top;

  headers.forEach((header) => {
    const headerState = header.getAttribute('data-header-state') || 'default';

    if (headerState === 'default') {
      if (topCompare < window.mdlrHeaderScrollPos || topCompare < wh / 3) {
        header.classList.remove('inactive');
      } else {
        header.classList.add('inactive');
      }
      return;
    }

    if (headerState === 'above-fold') {
      if (topCompare > wh / 3) {
        header.classList.add('inactive');
      } else {
        header.classList.remove('inactive');
      }
      return;
    }

    if (headerState === 'below-fold') {
      if (topCompare > wh / 3) {
        header.classList.remove('inactive');
      } else {
        header.classList.add('inactive');
      }
    }
  });

  window.mdlrHeaderScrollPos = topCompare;
}

window.modulrHeaderScroll = modulrHeaderScroll;

function initHeader() {
  // Set initial state for below-fold headers (start inactive).
  document.querySelectorAll('[data-header-state="below-fold"]').forEach((header) => {
    header.classList.add('inactive');
  });

  // Set initial state for above-fold headers (start active).
  document.querySelectorAll('[data-header-state="above-fold"]').forEach((header) => {
    header.classList.remove('inactive');
  });

  let ticking = false;
  const onScroll = () => {
    if (ticking) return;
    ticking = true;
    requestAnimationFrame(() => {
      modulrHeaderScroll();
      ticking = false;
    });
  };

  window.addEventListener('scroll', onScroll, { passive: true });
  modulrHeaderScroll();

  return function destroy() {
    window.removeEventListener('scroll', onScroll);
  };
}

ready(initHeader, { scope: 'modulr-header' });
